<div class="row">
    <div *ngIf="needConfig == true" class="col-md-12 need-config">
        <div class="row">
            <div class="col-xl-4 offset-xl-4 col-md-6 offset-md-3 col-12">
                <div class="card block shadow">
                    <div class="card-header">
                        <div class="card-title">
                            <h2>Informations basiques</h2>
                        </div>
                    </div>
                    <div class="card-body col-md-12">
                        <div class="card-text row">
                            <div class="col-md-12">
                                <mat-form-field>
                                    <mat-label>Prix d'achat</mat-label>
                                    <!-- Champ vide (et non « 0 ») tant que rien n'est saisi ; le modèle garde 0 en interne -->
                                    <input matInput [ngModel]="favorite.price == 0 ? null : favorite.price"
                                           (ngModelChange)="favorite.price = $event; edit($event, 'price')">
                                    <span matSuffix>€</span>
                                    <mat-hint *ngIf="favorite.price == 0 && display_errors == true" class="text-red">
                                        Veuillez renseigner le prix
                                    </mat-hint>
                                </mat-form-field>
                            </div>

                            <div class="col-md-12">
                                <mat-form-field>
                                    <mat-label>Loyer</mat-label>
                                    <input matInput [ngModel]="favorite.amount_rent == 0 ? null : favorite.amount_rent"
                                           (ngModelChange)="favorite.amount_rent = $event; edit($event)">
                                    <span matSuffix>€/mois</span>
                                    <mat-hint *ngIf="favorite.amount_rent == 0 && display_errors == true"
                                              class="text-red">
                                        Veuillez renseigner le loyer
                                    </mat-hint>
                                </mat-form-field>
                            </div>

                            <div class="col-12">
                                <a class="btn d-block" (click)="showResults()">
                                    Valider
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-9">
        <div class="row">
            <div class="col-md-6">
                <div class="card block">
                    <div class="card-header">
                        <div class="card-title">
                            <h2>Achat</h2>
                        </div>
                    </div>
                    <div class="card-body col-md-12">
                        <div class="card-text row">
                            <div class="col-md-6">
                                <mat-form-field>
                                    <mat-label>Prix d'achat FAI</mat-label>
                                    <input matInput [(ngModel)]="favorite.price"
                                           (ngModelChange)="edit($event, 'price')">
                                    <span matSuffix>€</span>
                                    <mat-hint *ngIf="favorite.price == 0" class="text-red">
                                        Veuillez renseigner le prix
                                    </mat-hint>
                                    <mat-hint *ngIf="favorite.price > 0" class="text-blue">
                                        Net vendeur : {{ favorite.price - favorite.agency_fees | number:'1.0-0' }} €
                                    </mat-hint>
                                </mat-form-field>
                            </div>

                            <div class="col-md-6">
                                <mat-form-field>
                                    <mat-label>Prix Mobiliers / Électroménager</mat-label>
                                    <input matInput [(ngModel)]="favorite.furniture_price"
                                           (ngModelChange)="edit($event)">
                                    <span matSuffix>€</span>
                                </mat-form-field>
                            </div>

                            <div class="col-md-6">
                                <mat-form-field>
                                    <mat-label>Frais de notaire</mat-label>
                                    <input matInput [(ngModel)]="favorite.notary_price" (ngModelChange)="edit($event)">
                                    <span matSuffix>€</span>
                                    <mat-hint *ngIf="favorite.estate_sale == 'Ancien'">Entre 8 et 9% pour l'ancien
                                    </mat-hint>
                                    <mat-hint *ngIf="favorite.estate_sale == 'Neuf'">De 2 à 3% dans le neuf</mat-hint>
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <mat-form-field>
                                    <mat-label>Frais d'agence</mat-label>
                                    <input matInput [(ngModel)]="favorite.agency_fees" (ngModelChange)="edit($event)">
                                    <span matSuffix>€</span>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card block">
                    <div class="card-header">
                        <div class="card-title">
                            <h2>Revenus & Dépenses</h2>
                        </div>
                    </div>
                    <div class="card-body col-md-12">
                        <div class="card-text row">
                            <div class="col-md-12">
                                <mat-form-field>
                                    <mat-label>Loyer hors charges</mat-label>
                                    <input matInput [(ngModel)]="favorite.amount_rent" (ngModelChange)="edit($event)">
                                    <span matSuffix>€/mois</span>
                                    <mat-hint *ngIf="favorite.amount_rent == 0" class="text-red">
                                        Veuillez renseigner le loyer
                                    </mat-hint>
                                    <mat-hint *ngIf="favorite.amount_rent > 0" class="text-red">
                                        <br/>
                                    </mat-hint>
                                </mat-form-field>
                            </div>
                            <div class="col-md-12">
                                <mat-form-field>
                                    <mat-label>Total charges</mat-label>
                                    <input matInput [(ngModel)]="favorite.other_bill" (ngModelChange)="edit($event)">
                                    <span matSuffix>€/an</span>
                                    <mat-hint>Taxe foncière, gestion par agence, PNO, etc ...</mat-hint>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-md-6">
                <div class="card block">
                    <div class="card-header">
                        <div class="card-title">
                            <h2>Travaux</h2>
                        </div>
                    </div>
                    <div class="card-body col-md-12">
                        <div class="card-text row">

                            <div class="col-md-12">
                                <mat-form-field>
                                    <mat-label>Travaux envisagés</mat-label>
                                    <mat-select disableOptionCentering [(ngModel)]="favorite.works_help"
                                                (ngModelChange)="edit($event, 'works_help')"
                                                [disabled]="favorite.lots.length > 1">
                                        <mat-option [value]="0">Aucun travaux</mat-option>
                                        <!--                                <mat-option [value]="this.user.work_1">Rafraichissement ({{this.user.work_1}} €/m²)</mat-option>-->
                                        <!--                                <mat-option [value]="this.user.work_2">Renovation ({{this.user.work_2}} €/m²)</mat-option>-->
                                        <!--                                <mat-option [value]="this.user.work_3">Remise a neuf ({{this.user.work_3}} €/m²)</mat-option>-->
                                        <mat-option [value]="-1">Avec Travaux</mat-option>
                                    </mat-select>
                                    <mat-hint><br/></mat-hint>
                                </mat-form-field>
                            </div>
                            <!--                    <div class="col-md-6">-->
                            <!--                        <mat-form-field>-->
                            <!--                            <mat-label>Ratio</mat-label>-->
                            <!--                            <input matInput [(ngModel)]="favorite.works_square_price" (ngModelChange)="edit($event, 'works_square_price')" [disabled]="favorite.works_help != -1 || favorite.lots.length > 1">-->
                            <!--                            <span matSuffix>€/m²</span>-->
                            <!--                            <mat-hint><br/></mat-hint>-->
                            <!--                        </mat-form-field>-->
                            <!--                    </div>-->
                            <div class="col-md-12">
                                <mat-form-field>
                                    <mat-label>Montant total des travaux</mat-label>
                                    <input matInput [(ngModel)]="favorite.works_total"
                                           (ngModelChange)="edit($event, 'works_total')"
                                           [disabled]="favorite.works_help != -1 || favorite.lots.length > 1">
                                    <span matSuffix>€</span>
                                </mat-form-field>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card block">
                    <div class="card-header">
                        <div class="card-title">
                            <h2>Financement</h2>
                        </div>
                    </div>
                    <div class="card-body col-md-12">
                        <img *ngIf="preview" src="assets/widgets/achat.png" class="img-fluid"/>
                        <div class="card-text row" *ngIf="!preview">
                            <div class="col-md-6">
                                <mat-form-field>
                                    <mat-label>Apport</mat-label>
                                    <input matInput [(ngModel)]="favorite.apport" (ngModelChange)="edit($event)">
                                    <span matSuffix>€</span>
                                    <mat-hint><br/></mat-hint>
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <mat-form-field>
                                    <mat-label>Durée</mat-label>
                                    <input matInput [(ngModel)]="favorite.duration" (ngModelChange)="edit($event)">
                                    <span matSuffix>ans</span>
                                    <mat-hint *ngIf="favorite.duration == 0" class="text-red">
                                        Veuillez renseigner la durée
                                    </mat-hint>
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <mat-form-field>
                                    <mat-label>Taux du crédit</mat-label>
                                    <input matInput [(ngModel)]="favorite.rate" (ngModelChange)="edit($event)">
                                    <span matSuffix>%</span>
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <mat-form-field>
                                    <mat-label>Taux assurance</mat-label>
                                    <input matInput [(ngModel)]="favorite.rate_insurance"
                                           (ngModelChange)="edit($event)">
                                    <span matSuffix>%</span>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-3" *ngIf="needConfig == false">
        <div class="card block">
            <div class="card-header">
                <div class="card-title text-center">
                    <h2>Simulateur</h2>
                    <span class="mb-2 d-block">Ajuster les différents curseurs pour effectuer votre simulation :</span>
                </div>
            </div>
            <div class="card-body col-md-12">
                <div class="row">
                    <div class="col-md-12 mb-4">
                        <label>Prix :&nbsp;</label>
                        <b class="value">{{ favorite.price  | number:'1.0-0' }} <span class="unit">€</span>
                        </b>
                        <mat-slider
                            [max]="price == 0 ? 1000000 : price * 1.5"
                            [min]="price * 0.3"
                            [step]="500"
                            [thumbLabel]=false
                            (change)="edit($event, 'price')"
                            (input)="favorite.price = $event.value;edit($event, 'price')"
                            [displayWith]="commonService.euroLabel"
                            [(ngModel)]="favorite.price">
                        </mat-slider>
                    </div>
                    <div class="col-md-12 mb-4">
                        <label>Rendement brut :&nbsp;</label>
                        <b class="value">{{ favorite.efficiency_brut  | number:'1.0-1' }} <span
                            class="unit">%</span></b>
                        <mat-slider
                            [disabled]="favorite.amount_rent == 0 || favorite.price == 0"
                            [max]="25"
                            [min]="1"
                            [step]="0.1"
                            [thumbLabel]=false
                            (change)="updateEfficiency($event)"
                            (input)="favorite.efficiency_brut = $event.value;updateEfficiency($event)"
                            [displayWith]="commonService.percentLabel"
                            [(ngModel)]="favorite.efficiency_brut">
                        </mat-slider>
                    </div>
                    <div class="col-md-12 mb-4">
                        <label>Rendement net : </label>
                        <b class="value">{{ favorite.efficiency_net  | number:'1.0-1' }} <span class="unit">%</span></b>
                        <mat-slider
                            [disabled]="favorite.amount_rent == 0 || favorite.price == 0"
                            [max]="25"
                            [min]="1"
                            [step]="0.1"
                            [thumbLabel]=false
                            (change)="updateEfficiencyNet($event)"
                            (input)="favorite.efficiency_net = $event.value;updateEfficiencyNet($event)"
                            [displayWith]="commonService.percentLabel"
                            [(ngModel)]="favorite.efficiency_net">
                        </mat-slider>
                    </div>
                    <div class="col-md-12 mb-4">
                        <label>Loyer :&nbsp;</label>
                        <b class="value">{{ favorite.amount_rent  | number:'1.0-0' }} <span class="unit">€</span></b>
                        <mat-slider
                            [max]="price == 0 ? 10000 : price / 50"
                            [min]="0"
                            [step]="10"
                            [thumbLabel]=false
                            (change)="edit($event)"
                            (input)="favorite.amount_rent = $event.value;edit($event)"
                            [displayWith]="commonService.euroLabel"
                            [disabled]=""
                            [(ngModel)]="favorite.amount_rent">
                        </mat-slider>
                    </div>
                    <div class="col-md-12 mb-5">
                        <label>Travaux :&nbsp;</label>
                        <b class="value">{{ favorite.works_total  | number:'1.0-0' }} <span class="unit">€</span></b>
                        <mat-slider
                            [max]="price == 0 ? 1000000 : price * 2"
                            [min]="0"
                            [step]="250"
                            [thumbLabel]=true
                            (change)="edit($event, 'works_total')"
                            (input)="favorite.works_total = $event.value;edit($event, 'works_total')"
                            [displayWith]="commonService.euroLabel"
                            [(ngModel)]="favorite.works_total">
                        </mat-slider>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<button type="button" (click)="saveSimulation()" class="btn btn-primary saveSimulation" *ngIf="!needConfig">
    <i class="fa cfa cfa-save me-2"></i> Enregistrer votre simulation
</button>
